import React from 'react'
import houseMain from '../../images/landing/house-main.jpg'
import houseWhite from '../../images/landing/house-white.jpg'
import houseGlass from '../../images/landing/house-glass.jpg'
import houseOak from '../../images/landing/house-oak.jpg'

const photo = asset => (asset && asset.default) || asset

function SparklesIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9.94 14.06 2 22" />
      <path d="m12 2 2.4 5.6L20 10l-5.6 2.4L12 18l-2.4-5.6L4 10l5.6-2.4Z" />
    </svg>
  )
}

function CheckTiny() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

function WarnTiny() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </svg>
  )
}

export function DisclosuresCrop() {
  return (
    <div className="hlm-feature-crop">
      <div className="hlm-crop-head">
        <span className="hlm-crop-title">Disclosure package</span>
        <span className="hlm-pill hlm-pill-green">Shared</span>
      </div>
      <div className="hlm-crop-row">
        <span className="hlm-crop-row-label">Transfer disclosure statement</span>
        <span className="hlm-signed">Signed</span>
      </div>
      <div className="hlm-crop-row">
        <span className="hlm-crop-row-label">Seller property questionnaire</span>
        <span className="hlm-signed">Signed</span>
      </div>
      <div className="hlm-ai-box">
        <div className="hlm-ai-label">
          <SparklesIcon />
          AI SUMMARY
        </div>
        <div className="hlm-ai-cols">
          <div className="hlm-ai-col">
            <div className="hlm-ai-col-title is-green">Working in your favor</div>
            <div>
              Roof replaced in 2019&nbsp;<span className="hlm-page-ref">(p. 2)</span>
            </div>
            <div>
              New water heater&nbsp;<span className="hlm-page-ref">(p. 8)</span>
            </div>
          </div>
          <div className="hlm-ai-col">
            <div className="hlm-ai-col-title is-amber">What stands out</div>
            <div>
              Minor foundation crack&nbsp;<span className="hlm-page-ref">(p. 14)</span>
            </div>
            <div>
              High fire hazard zone&nbsp;<span className="hlm-page-ref">(p. 31)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const buyers = [
  {ini: 'PA', name: 'Pat Agent', meta: "Buyer's agent · 37 of 37 docs · 9 visits", score: 88, tier: 'Hot', pill: 'hlm-pill-hot'},
  {ini: 'JB', name: 'Jamie Buyer', meta: 'Buyer · 37 of 37 docs · 6 visits', score: 76, tier: 'Hot', pill: 'hlm-pill-hot'},
  {ini: 'SA', name: 'Sally Agent', meta: "Buyer's agent · 31 of 37 docs · 4 visits", score: 63, tier: 'Warm', pill: 'hlm-pill-warm'},
  {ini: 'KB', name: 'Kim Buyer', meta: 'Buyer · 6 of 37 docs · 1 visit', score: 24, tier: 'Cool', pill: 'hlm-pill-cool'},
]

export function BuyersCrop() {
  return (
    <div className="hlm-feature-crop">
      <div className="hlm-crop-head">
        <span className="hlm-crop-title">Buyer activity</span>
        <span className="hlm-crop-meta">Ranked by engagement score</span>
      </div>
      <div style={{marginTop: 12}}>
        {buyers.map(buyer => (
          <div className="hlm-buyer-row" key={buyer.name}>
            <span className="hlm-avatar">{buyer.ini}</span>
            <span className="hlm-buyer-copy">
              <strong>{buyer.name}</strong>
              <span>{buyer.meta}</span>
            </span>
            <span className="hlm-buyer-score">{buyer.score}</span>
            <span className={`hlm-pill ${buyer.pill}`}>{buyer.tier}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

const offers = [
  {
    price: '$1,825,000',
    meta: '· Loan · 30 days',
    who: 'Jane Agent · Sample Homes',
    status: 'Complete',
    statusClass: 'is-ok',
    net: '$1,702,000',
    highlight: true,
    warn: false,
  },
  {
    price: '$1,750,000',
    meta: '· Loan · 21 days',
    who: 'John Agent · Example Realty',
    status: 'Missing pre-approval',
    statusClass: 'is-warn',
    net: '$1,603,000',
    highlight: false,
    warn: true,
  },
  {
    price: '$1,650,000',
    meta: '· Cash · 14 days',
    who: 'Sally Agent · Demo Brokerage',
    status: 'Complete',
    statusClass: 'is-ok',
    net: '$1,461,000',
    highlight: false,
    warn: false,
  },
]

export function OffersCrop() {
  return (
    <div className="hlm-feature-crop">
      <div className="hlm-crop-head">
        <span className="hlm-crop-title">Offers (3)</span>
        <span className="hlm-crop-meta" style={{fontSize: 13}}>
          Est. net to seller
        </span>
      </div>
      {offers.map((offer, index) => (
        <div
          className={`hlm-offer-row${offer.highlight ? ' is-highlight' : ''}${!offer.highlight && index < offers.length - 1 ? ' is-plain' : ''}${
            index === offers.length - 1 && !offer.highlight ? ' is-last' : ''
          }`}
          key={offer.price}>
          <span className="hlm-offer-main">
            <span>
              <b style={{fontWeight: 600}}>{offer.price}</b> <span style={{color: '#475569'}}>{offer.meta}</span>
            </span>
            <span>{offer.who}</span>
          </span>
          <span className={`hlm-offer-status ${offer.statusClass}`}>
            {offer.warn ? <WarnTiny /> : <CheckTiny />}
            {offer.status}
          </span>
          <span className="hlm-offer-net">{offer.net}</span>
        </div>
      ))}
    </div>
  )
}

const PHOTO = photo(houseMain)
const PHOTO2 = photo(houseWhite)
const PHOTO3 = photo(houseGlass)
const PHOTO4 = photo(houseOak)

export function StudioCrop() {
  return (
    <div className="hlm-feature-crop is-flush">
      <div className="hlm-studio-top">
        <div className="hlm-crop-head" style={{marginBottom: 10}}>
          <span style={{fontSize: 14, fontWeight: 600}}>Ready to share</span>
          <span className="hlm-crop-meta">123 Main Street</span>
        </div>
        <div className="hlm-studio-assets">
          <div className="hlm-studio-asset">
            <span className="hlm-studio-asset-icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18" />
                <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18" />
              </svg>
            </span>
            <span>
              <strong>Property website</strong>
              <span className="hlm-studio-status" style={{color: '#1192e5'}}>
                <span className="dot" style={{background: '#1192e5'}} />
                Live
              </span>
            </span>
          </div>
          <div className="hlm-studio-asset">
            <span className="hlm-studio-asset-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
                <path d="M14 3v5h5" />
                <path d="M9 13h6" />
                <path d="M9 17h4" />
              </svg>
            </span>
            <span>
              <strong>Open house flyer</strong>
              <span className="hlm-studio-status" style={{color: '#15803d'}}>
                <span className="dot" style={{background: '#15803d'}} />
                Ready
              </span>
            </span>
          </div>
          <div className="hlm-studio-asset">
            <span className="hlm-studio-asset-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="4" y="3" width="16" height="18" rx="2" />
                <path d="M8 7h8" />
                <path d="M8 11h8" />
                <path d="M8 15h5" />
              </svg>
            </span>
            <span>
              <strong>Feature sheet</strong>
              <span className="hlm-studio-status" style={{color: '#15803d'}}>
                <span className="dot" style={{background: '#15803d'}} />
                Ready
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="hlm-studio-social">
        <span>
          Social posts <span style={{fontWeight: 400, color: '#64748b'}}>· scheduled this week</span>
        </span>
        <span className="hlm-studio-legend">
          <span>
            <span className="dot" style={{width: 7, height: 7, borderRadius: 9999, background: '#f59e0b', display: 'inline-block'}} />
            <b style={{fontWeight: 600}}>3</b> scheduled
          </span>
          <span>
            <span className="dot" style={{width: 7, height: 7, borderRadius: 9999, background: '#22c55e', display: 'inline-block'}} />
            <b style={{fontWeight: 600}}>1</b> published
          </span>
        </span>
      </div>
      <div className="hlm-studio-days">
        {[
          ['SUN', '11'],
          ['MON', '12'],
          ['TUE', '13', true],
          ['WED', '14'],
          ['THU', '15'],
          ['FRI', '16'],
          ['SAT', '17'],
        ].map(([day, date, today]) => (
          <div className={`hlm-studio-day${today ? ' is-today' : ''}`} key={day}>
            {day} <span>{date}</span>
          </div>
        ))}
      </div>
      <div className="hlm-studio-cal">
        <div className="hlm-studio-cell" />
        <div className="hlm-studio-cell">
          <div className="hlm-studio-post">
            <span className="hlm-studio-thumb" style={{backgroundImage: `url(${PHOTO})`}} />
            <span className="hlm-studio-time">
              <span className="dot" style={{width: 6, height: 6, borderRadius: 9999, background: '#15803d', flex: '0 0 6px'}} />
              9 am
            </span>
          </div>
        </div>
        <div className="hlm-studio-cell is-today">
          <div className="hlm-studio-post">
            <span className="hlm-studio-thumb" style={{backgroundImage: `url(${PHOTO2})`}} />
            <span className="hlm-studio-time">
              <span className="dot" style={{width: 6, height: 6, borderRadius: 9999, background: '#d97706', flex: '0 0 6px'}} />
              12 pm
            </span>
          </div>
        </div>
        <div className="hlm-studio-cell" />
        <div className="hlm-studio-cell">
          <div className="hlm-studio-post">
            <span className="hlm-studio-thumb" style={{backgroundImage: `url(${PHOTO3})`}} />
            <span className="hlm-studio-time">
              <span className="dot" style={{width: 6, height: 6, borderRadius: 9999, background: '#d97706', flex: '0 0 6px'}} />
              9 am
            </span>
          </div>
        </div>
        <div className="hlm-studio-cell" />
        <div className="hlm-studio-cell">
          <div style={{display: 'flex', alignItems: 'center', gap: 3, fontSize: 10, color: '#273653', whiteSpace: 'nowrap', overflow: 'hidden'}}>
            OH 1–4
          </div>
          <div className="hlm-studio-post">
            <span className="hlm-studio-thumb" style={{backgroundImage: `url(${PHOTO4})`}} />
            <span className="hlm-studio-time">
              <span className="dot" style={{width: 6, height: 6, borderRadius: 9999, background: '#d97706', flex: '0 0 6px'}} />
              8 am
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
